<template>
    <div class="placeholder">
        <div class="placeholder__heading">
            <d-tooltip placement="left" identifier="oekonomi.kostprisPrTime" />
            Kostpris pr. time
        </div>
        <div class="placeholder padding box" v-if="data && !loading && data.accounts_total && data.total_hours">
            <div class="large">
                {{ data.costprice_per_hour | currency }}
            </div>
            <div class="meta">
                Udregningen er baseret på de totale udgifter til svende divideret med antal timer brugt hos kunderne i perioden
                <!--<div class="toggle" @click="showCalculations = !showCalculations">
                    <span v-if="!showCalculations">
                        Vis udregning
                        <i class="fal fa-chevron-down fa-fw" />
                    </span>
                    <span v-else>
                        Skjul udregning
                        <i class="fal fa-chevron-up fa-fw" />
                    </span>
                </div>-->
                <div class="divider" />
                <div class="accounts" v-if="showCalculations">
                    <div class="account" v-for="account in data.calculations" :key="account.uuid">
                        <div class="name">
                            {{ account.name }}
                        </div>
                        <div class="value">
                            {{ Math.abs(account.total) | currency }}
                        </div>
                    </div>
                    <div class="account total">
                        <div class="name">
                            Total
                        </div>
                        <div class="value">
                            {{ data.accounts_total | currency }}
                        </div>
                    </div>
                    <br>
                    <div class="account total">
                        <div class="name">
                            Antal timer hos kunderne
                        </div>
                        <div class="value">
                            {{ data.total_hours | number }}
                        </div>
                    </div>
                    <!--<br>
                    <div class="account total">
                        <div class="name">
                            Kostpris pr. time
                        </div>
                        <div class="value">
                            {{ data.costprice_per_hour | currency }}
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
        <box-loading height="350" v-else-if="!data && loading" />
        <div class="placeholder padding" v-else>
            Vi kunne ikke udregne kostprisen. Tjek, at du har angivet hvilke medarbejdere og konti, der skal regnes med i denne udregning. Dette kan du ændre i indstillingerne
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .placeholder {
        height: fit-content;
    }

    .box {
        text-align: center;
        font-family: $fontfamily--main;
        line-height: 1.5;

        .large {
            font-size: $fontsize--xl;
            margin-bottom: $margin--small;
            font-weight: 600;
        }
    }

    .toggle {
        margin-top: $margin--small;
        cursor: pointer;

        &:hover {
            font-weight: 600;
        }
    }

    .account {
        display: flex;
        justify-content: space-between;

        &.total {
            font-weight: 600;
        }
    }

</style>

<script>
import * as economyService from '@/services/economyService'

export default {
    data () {
        return {
            loading: false,
            showCalculations: true,
            data: null
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.data = null
            // let currentAccountingYear = this.$store.getters.getCurrentAccountingYear
            let params = {
                // date_from: currentAccountingYear.from_date,
                // date_to: currentAccountingYear.to_date
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            economyService.costpricePerHour(params, (response) => {
                this.data = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// costpricePerHour.vue?68bce431